import React, { useState } from "react";
import Modal from "react-modal";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FieldGroup, SubmitButton } from "..";
import axios from "axios";

try {
  Modal.setAppElement("#app");
} catch (e) {
  // #app exists only in the real document (index.html). Under vitest/jsdom it
  // is absent at import time, and react-modal needs it only to aria-hide the
  // page behind an open modal — worth nothing to report and nothing to fix.
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
  },
};

const CreateAppInviteModal = ({ open, closeModal, afterSubmit }) => {
  const [submitting, setSubmitting] = useState(false);

  const validationSchema = Yup.object({
    name: Yup.string().required("Invite name is required"),
  });

  const onSubmit = async (data) => {
    setSubmitting(true);
    const response = await axios.post("/api/invites", data);
    setSubmitting(false);

    if (afterSubmit) {
      afterSubmit(response.data);
      closeModal();
    }
  };

  return (
    <Modal isOpen={open} onRequestClose={closeModal} style={customStyles}>
      <Formik
        initialValues={{ name: "", code: "" }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Form>
          <div className="content m-3">
            <p className="text-center">CREATE NEW APP INVITE</p>
            <FieldGroup placeholder="Invite Name" type="text" name="name" />
            <FieldGroup placeholder="Invite Code" type="text" name="code" />
          </div>
          <div className="d-flex justify-content-center mb-3">
            <SubmitButton isSubmitting={submitting} label="Add to list" />
          </div>
        </Form>
      </Formik>
    </Modal>
  );
};

export default CreateAppInviteModal;
